import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=25cc7fb6&scoped=true&"
import script from "./tags.vue?vue&type=script&lang=js&"
export * from "./tags.vue?vue&type=script&lang=js&"
import style0 from "./tags.vue?vue&type=style&index=0&id=25cc7fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cc7fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/www/xmg-cms-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('25cc7fb6', component.options)
    } else {
      api.reload('25cc7fb6', component.options)
    }
    module.hot.accept("./tags.vue?vue&type=template&id=25cc7fb6&scoped=true&", function () {
      api.rerender('25cc7fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cat-base/tags.vue"
export default component.exports